import { ApiCore } from "@/services/api/utils/core.js";

const url = "v1/health";
const plural = "healths";
const single = "health";

const health = new ApiCore({
	index: true,
	findOne: false,
	create: false,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single,
});

export default health;
